import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CheckCircle } from 'lucide-react';

const LogoutCallback = () => {
  const [status, setStatus] = useState('processing');
  const { handleLogoutCallback } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const processLogoutCallback = async () => {
      try {
        setStatus('processing');
        await handleLogoutCallback();
      } catch (logoutError) {
        console.error('Logout callback error:', logoutError);
      } finally {
        setStatus('success');
        setTimeout(() => navigate('/login', { replace: true }), 1500);
      }
    };

    processLogoutCallback();
  }, [handleLogoutCallback, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-50 via-brand-100 to-brand-200 p-4">
      <div className="max-w-md w-full">
        <div className="card">
          <div className="text-center">
            {status === 'processing' ? (
              <>
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-600 mx-auto mb-4" />
                <h2 className="text-xl font-semibold text-brand-900 mb-2">Completing Logout</h2>
                <p className="text-brand-700">Please wait while we complete your sign-out...</p>
              </>
            ) : (
              <>
                <div className="mx-auto h-12 w-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                  <CheckCircle className="h-8 w-8 text-green-600" />
                </div>
                <h2 className="text-xl font-semibold text-brand-900 mb-2">Logout Successful</h2>
                <p className="text-brand-700">You have been signed out.</p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutCallback;
